import api from '@/api_alv'
import Vue from 'vue'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'
import { 
    DropdownGenericCostGroupTypes, 
    DropdownLabelReleasesBudgetGroupTypes  
} from '@/assets/dropdowns/alvDropdowns.js'

const DIR = 'label/projects'

// DEFAULTS
const DEFAULT_PROJECT = {
    'title'             : null, 
    'id'                : 0, 
    'alvId'             : 'ALV000000000LP',
    'tag'               : null,
    'note'              : null,
    'image'             : null,
    'projectNumber'     : null,
    'projectStartDate'  : null,
    'url'               : null
}

const state = {
// LIST
    labelProjects: [],
    selectedLabelProjects: [],
    isAllSelectedLabelProjects: false,
    expandedLabelProjects: [],
    labelProjectsServerSideSortingOptions:{
        sortBy: ['title'],
        sortDesc: [false],
        mustSort: true
    },

    // Filters
    labelProjectsSearch: '',

    // Actions
    selectedLabelProjectsAction: [],

// DETAILS
    defaultLabelProject: DEFAULT_PROJECT,
    labelProjectsDetails: DEFAULT_PROJECT,
    // Releases Panel
    labelProjectsReleases: [],
    projectsReleasesSearch: '',
    selectedProjectsReleases: [],
    // Profit & Loss
    // projectsProfitAndLoss: {},
    projectsProfitAndLossResult: 0,
    projectsProfitAndLossCosts: [],
    projectsProfitAndLossIncome: [],
    projectsProfitAndLossIsLoading: false,
    // Filter
    selectedProjectsProfitAndLossFilterCostGroup: null,
    selectedProjectsProfitAndLossFilterIncomeGroup: null,
    projectProfitAndLossFilterDetailsFromMonth: null,
    projectProfitAndLossFilterDetailsToMonth: null,
}

const getters = {
    
    // List
    getLabelProjects                                    (state) { return state.labelProjects },
    getSelectedLabelProjects                            (state) { return state.selectedLabelProjects },
    getIsAllSelectedLabelProjects                       (state) { return state.isAllSelectedLabelProjects },
    getExpandedLabelProjects                            (state) { return state.expandedLabelProjects },
    getLabelProjectsServerSideSortingOptions            (state) { return state.labelProjectsServerSideSortingOptions },

    // Filters
    getLabelProjectsSearch                              (state) { return state.labelProjectsSearch },

    // Actions
    getSelectedLabelProjectsAction                      (state) { return state.selectedLabelProjectsAction },

    // Details
    getDefaultLabelProject                              (state) { return state.defaultLabelProject },
    getLabelProjectsDetails                             (state) { return state.labelProjectsDetails },

    // Edit Form Fields
    getLabelProjectsDetailsAlvId                        (state) { return state.labelProjectsDetails.alvId },
    getLabelProjectsDetailsTitle                        (state) { return state.labelProjectsDetails.title },
    getLabelProjectsDetailsProjectnumber                (state) { return state.labelProjectsDetails.projectNumber },
    getLabelProjectsDetailsNotes                        (state) { return state.labelProjectsDetails.note },
    getLabelProjectsDetailsProjectDate                  (state) { return state.labelProjectsDetails.projectStartDate },
    getLabelProjectsDetailsUrl                          (state) { return state.labelProjectsDetails.url },
    getLabelProjectsDetailsTags                         (state) { return state.labelProjectsDetails.tag },
    
    // Releases Panel
    getLabelProjectsReleases                            (state) { return state.labelProjectsReleases },
    getProjectsReleasesSearch                           (state) { return state.projectsReleasesSearch },
    getSelectedProjectsReleases                         (state) { return state.selectedProjectsReleases },

    // Profit & Loss
    getProjectsProfitAndLossResult                      (state) { return state.projectsProfitAndLossResult },
    getProjectsProfitAndLossCosts                       (state) { return state.projectsProfitAndLossCosts },
    getProjectsProfitAndLossIncome                      (state) { return state.projectsProfitAndLossIncome },
    getProjectsProfitAndLossIsLoading                   (state) { return state.projectsProfitAndLossIsLoading },

    // Filter
    getSelectedProjectsProfitAndLossFilterCostGroup     (state) { return state.selectedProjectsProfitAndLossFilterCostGroup },
    getSelectedProjectsProfitAndLossFilterIncomeGroup   (state) { return state.selectedProjectsProfitAndLossFilterIncomeGroup},
    getProjectProfitAndLossFilterDetailsFromMonth       (state) { return state.projectProfitAndLossFilterDetailsFromMonth },
    getProjectProfitAndLossFilterDetailsToMonth         (state) { return state.projectProfitAndLossFilterDetailsToMonth },
}

const mutations = {

    // List
    setLabelProjects:                                   (state, value) => { state.labelProjects = value },
    setSelectedLabelProjects:                           (state, value) => { state.selectedLabelProjects = value },
    setIsAllSelectedLabelProjects:                      (state, value) => { state.isAllSelectedLabelProjects = value },
    setExpandedLabelProjects:                           (state, value) => { state.expandedLabelProjects = [value] },
    setLabelProjectsServerSideSortingOptions:           (state, value) => { state.labelProjectsServerSideSortingOptions = value },

    // Filters
    setLabelProjectsSearch:                             (state, value) => { state.labelProjectsSearch = value },

    // Actions
    setSelectedLabelProjectsAction:                     (state, value) => { state.selectedLabelProjectsAction = value },

    // Details
    setDefaultLabelProject:                             (state) => { state.defaultLabelProject = DEFAULT_PROJECT },
    setLabelProjectsDetails:                            (state, value) => { state.labelProjectsDetails = value },
    
    // Edit Form Fields
    setLabelProjectsDetailsAlvId:                       (state, value) => { state.labelProjectsDetails.alvId = value },
    setLabelProjectsDetailsTitle:                       (state, value) => { state.labelProjectsDetails.title = value },
    setLabelProjectsDetailsProjectnumber:               (state, value) => { state.labelProjectsDetails.projectNumber = value },
    setLabelProjectsDetailsNotes:                       (state, value) => { state.labelProjectsDetails.note = value },
    setLabelProjectsDetailsProjectDate:                 (state, value) => { state.labelProjectsDetails.projectStartDate = value },
    setLabelProjectsDetailsUrl:                         (state, value) => { state.labelProjectsDetails.url = value },
    setLabelProjectsDetailsTags:                        (state, value) => { state.labelProjectsDetails.tag = value },

    // Releases Panel
    setLabelProjectsReleases:                           (state, value) => { state.labelProjectsReleases = value },
    setProjectsReleasesSearch:                          (state, value) => { state.projectsReleasesSearch = value },
    setSelectedProjectsReleases:                        (state, value) => { state.selectedProjectsReleases = value },

    // Profit & Loss
    setProjectsProfitAndLossResult:                     (state, value) => { state.projectsProfitAndLossResult = value },
    setProjectsProfitAndLossCosts:                      (state, value) => { state.projectsProfitAndLossCosts = value },
    setProjectsProfitAndLossIncome:                     (state, value) => { state.projectsProfitAndLossIncome = value },
    setProjectsProfitAndLossIsLoading:                  (state, value) => { state.projectsProfitAndLossIsLoading = value },

    // Filter
    setSelectedProjectsProfitAndLossFilterCostGroup:    (state, value) => { state.selectedProjectsProfitAndLossFilterCostGroup = value },
    setSelectedProjectsProfitAndLossFilterIncomeGroup:  (state, value) => { state.selectedProjectsProfitAndLossFilterIncomeGroup = value },
    setProjectProfitAndLossFilterDetailsFromMonth:      (state, value) => { state.projectProfitAndLossFilterDetailsFromMonth = value },
    setProjectProfitAndLossFilterDetailsToMonth:        (state, value) => { state.projectProfitAndLossFilterDetailsToMonth = value },
}

const actions = {
// LIST
    async fetchLabelProjects({ commit, getters }) {
        commit('setIsLoading', true)

        // Filters
        let filterObj = {
            'search' : getters.getLabelProjectsSearch
        }
        // let paramsStringForApiCall = this._vm.$alvPlugin.createApiUrlFilterString(filterObj) // Build string with filter params for the api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj) // Build string with filter params for the api call

        // API Call
        let values
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsStringForApiCall)

        let options = getters.getLabelProjectsServerSideSortingOptions
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)  

        // Catch errors
        if(response === undefined || (response.hasOwnProperty('list') ? response.list.length === 0 : false) || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            values = []
        } else {
            values = response.list
        }

        // Update paging information
        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)

        // Set list items
        commit('setLabelProjects', values)
        

        commit('setIsLoading', false)
    },

// DETAILS
    // Fetch edit form details 
    async fetchLabelProjectsDetails({ commit, getters, dispatch }, alvId) {
        let values

        // If its a new Project set default values for edit form, if not do an details API Call
        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultLabelProject)) 
            values = defaultValues
        } else {
            // API Call
            let response = await api.getDetailsById(DIR, alvId)

            // Catch errors
            if (response === undefined || response.length === 0 || response.error === 1) {
                values = {}
            } else {
                values = response
            }
        }

        // Set Project detail values
        commit('setLabelProjectsDetails', values)

        // Set Panel Values
        dispatch('fetchLabelProjectReleases')

        commit('setIsLoading', false)
    },

    // Save edit form
    async saveLabelProjectsForm({ commit, getters, dispatch }) {
        let alvId = getters.getLabelProjectsDetailsAlvId
        let metaData = getters.getLabelProjectsDetails
        metaData['releases'] = getters.getLabelProjectsReleases
        let isNew = router.currentRoute.params.alvId == "new"

        // API Call for saving
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        // Catch errors
        if(response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_SAVING_FAILED')
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_PUBLISHING_PROJECTS_SNACKBAR_PROJECT_SAVED')
            })

            // If it is a new created project the page will be reloaded with 
            // the new created alvid from the db
            if(isNew) {
                router.push( { name: 'LabelProjectsEdit', params: { alvId: response.response.alvId }} )
            }

            // refresh data
            await dispatch('fetchLabelProjectsDetails', response.response.alvId)
        }
    },

    // ACTIONS Switch
    async doLabelProjectsAction({ commit, dispatch }) {
        if(state.selectedLabelProjects.length > 0) {
            switch(state.selectedLabelProjectsAction) {
                case 'delete':
                    commit('setShowDeletionDialog', true)
                    break
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)	
        }
    },

    // Action: DELETE
    async deleteSelectedLabelProjects({ commit, getters, dispatch }) {  
        let selectedProjects = getters.getSelectedLabelProjects
        let projects = getters.getLabelProjects
        const response = await api.deleteEntries(DIR, selectedProjects)

        if(response.error === -1) {        
            for(let i = 0; i < selectedProjects.length; i++) {
                let index = projects.findIndex(project => project.alvId == selectedProjects[i])
                Vue.delete(projects, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedLabelProjects', [])
            commit('setSelectedLabelProjectsAction', [])
            dispatch('fetchLabelProjects')
        }
    },

// PANELS
    // Releases
    async fetchLabelProjectReleases({ commit, getters }) {
        let releases = getters.getLabelProjectsDetails.releases

        // Catch error
        if(releases === undefined || releases === null) releases = []
        if(releases.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 

        // Set values
        commit('setLabelProjectsReleases', releases)
    },

    // Search for releases to add to project
    async searchProjectsReleases({ getters }) {
        let params = "search=" + getters.getProjectsReleasesSearch

        let response = await api.getFilteredResults('label/releases', params)

        return response.list
    },

    // Add releases to project
    async addReleaseToProjects({ getters, commit}, selectedItems) {
        let releases = getters.getLabelProjectsReleases
        let startAmount = releases.length

        for(let i = 0; i < selectedItems.length; i++) {
            releases.push(selectedItems[i])
        }

        let newAmount = releases.length

        if(newAmount > startAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON')
            })
        }
    },

    // Delete releases from project
    async deleteSelectedProjectsReleases({commit, getters}) {
        let selectedRelease = getters.getSelectedProjectsReleases
        let selectedReleaseAlvId = selectedRelease.alvId
        let connectedReleases = getters.getLabelProjectsReleases
        let index = connectedReleases.findIndex(release => release.alvId === selectedReleaseAlvId)

        let startAmount = getters.getLabelProjectsReleases.length
        Vue.delete(connectedReleases, index)
        let newAmount = getters.getLabelProjectsReleases.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedProjectsReleases', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // Profit & Loss
    async fetchProjectsProfitAndLoss({ getters, commit}) {
        commit('setProjectsProfitAndLossIsLoading', true)

        let fromMonth = getters.getProjectProfitAndLossFilterDetailsFromMonth
        let ToMonth = getters.getProjectProfitAndLossFilterDetailsToMonth
        let params = "fromMonth=" + fromMonth + '&toMonth=' + ToMonth
        let projectAlvId = getters.getLabelProjectsDetailsAlvId

        let response = await api.getProfitAndLossResult(DIR + '/' + projectAlvId + '/profitAndLoss', params)

        // convert the costs and income objects from BE to arrays (v-data-table needs array)
        let costs = []
        let income = []
        Object.values(response.costs).forEach(value => costs.push(value))
        Object.values(response.income).forEach((value, index) => {
            value['id'] = index
            return income.push(value)
        })

        commit('setProjectsProfitAndLossResult', response.totalSum)
        commit('setProjectsProfitAndLossCosts', costs)
        commit('setProjectsProfitAndLossIncome', income)

        commit('setProjectsProfitAndLossIsLoading', false)
    },
}

export default {
    state, getters, actions, mutations
}